import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface ScopeState {
  participationId: string | null;
  set: (id: string | null) => void;
}

/** The expo participation currently in focus across the admin dashboard (§46). */
export const useScope = create<ScopeState>()(
  persist(
    (set) => ({
      participationId: null,
      set: (id) => set({ participationId: id }),
    }),
    { name: 'jx_scope' },
  ),
);
